import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

const EMPTY = { name: "", id_number: "", email: "", phone: "", address: "" };
const FIELDS = [
  ["name", "Nombre / Razón social"],
  ["id_number", "Cédula física / jurídica"],
  ["email", "Correo"],
  ["phone", "Teléfono"],
  ["address", "Dirección"],
];

export const ClientDialog = ({ open, onOpenChange, client, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => {
    if (open) setF(client ? { ...EMPTY, ...client } : EMPTY);
  }, [open, client]);

  const save = async () => {
    if (!f.name.trim()) return toast.error("El nombre es obligatorio");
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, f[k]]));
      const { data } = client ? await api.put(`/clients/${client.id}`, body) : await api.post("/clients", body);
      toast.success(client ? "Cliente actualizado" : "Cliente registrado");
      onSaved(data);
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#120E2E] border-[#271E56] max-w-lg" data-testid="client-dialog">
        <DialogHeader>
          <DialogTitle className="text-white font-display">{client ? "Editar cliente" : "Nuevo cliente"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className="space-y-1.5">
              <Label className="label-cap">{label}</Label>
              <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`client-${k}-input`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button className="btn-neon" onClick={save} data-testid="client-save-btn">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
